const data = {
  a: [
    {
      author_zh: "吳克威、蔡郁柔",
      author_en: "Wu Ke-Wei, Tsai Yu-Jou",
      title_zh: "聖地：火燒島旅遊指南",
      title_en: "Holy Land: Fire Island Travel Guide",
      date: "3/19、3/22",
      location_zh: "地點：綠島國民中學",
      location_en: "Venue: Lyudao Junior High School",
      intro_zh: "<p>透過工作坊的引導，在地學生將綠島秘境及自己和這個地方的故事書寫成信，與來到綠島工作、創作、流浪的人對話。</p>",
      intro_en: "<p>With an epistolary approach, students are guided to suggest places to visit on Green Island and their stories with the island, creating dialogues with people who come here to work, create and simply roam.</p>",
      url:"https://medium.com/greenislandhumanrightartfestival/workshop-聖地-火燒島旅遊指南-20c63c414e66",
    },
    {
      author_zh: "陳品蓉",
      author_en: "Chen Ping-Jung",
      title_zh: "如願已償",
      title_en: "The Paid Off",
      date: "3/27",
      location_zh: "地點：綠島公館鄉社區活動中心",
      location_en: "Venue: Lyudao Gong Guan Community Center",
      intro_zh: "<p>綠島，好多人在這塊土地上來來去去。有些初訪，有些不再離去。關於「留在綠島」，每個人有各種想像和原因，透過工作坊與居民帶來的生活和工作經驗，交流生命中的「移動故事」。</p>",
      intro_en: "<p>So many people have visited and left Green Island. Some stay briefly and some forever. Everyone has his or her ideas and reasons about “staying on Green island.” In the workshop, participants exchange “stories of movement” with local inhabitants about  life and work.</p>",
      url:"https://medium.com/greenislandhumanrightartfestival/workshop-如願已償-90cc4b754d51",
    },
  ],
  b: [
    {
      author_zh: "劉紀彤",
      author_en: "Liu Chi-Tung",
      title_zh: "拜訪老園丁",
      title_en: "A Visit to the Senior Gardener",
      date: "5/1 (六） 13:00-16:30",
      location_zh: "地點：台中東海花園",
      location_en: "Taichung Tunghai Garden",
      intro_zh: "<p>拜訪楊逵先生故居—東海花園，楊逵在出獄離開綠島後，晚年以身體勞動砌成的鵝卵石花園。連結受難者依賴的水源、家書通信的地址流麻溝，一個位於綠島，已然消失；另一個位於臺中，處於不穩定的狀態。</p>",
      intro_en: "<p>After being released from Green Island, Yang Kui spent his silver years building and handcrafting a pebble garden through physical labor. The visit links together Tunghai Garden, Yang Kui’s residence, and Liumagou, an indispensable water source for political victims on Green Island and the sender’s address on their home letters. One was on Green Island and has now faded into history; the other is located in Taichung and faces a precarious fate today.</p>",
      url:"https://medium.com/greenislandhumanrightartfestival/拜訪老園丁工作坊-b60edb6cc6f2",
    },
    {
      author_zh: "梁綉怡",
      author_en: "Liang Siou-Yi",
      title_zh: "閱讀，一幅綠島圖像",
      title_en: "Read, a Picture of Green Island",
      date: "5/14（五）13:15-15:50．5/17（一）13:15-15:50",
      location_zh: "地點：綠島國民中學",
      location_en: "Venue: Lyudao Junior High School",
      intro_zh: "<p>透過閱讀、思考，我們試圖理解過去，看見未曾參與的年代和腳下土地，連結現在，以自己的生命經驗給予回應。藉著顏色與形狀的聯想、剪貼，將文字轉化為視覺創作，拼貼出一幅屬於我們、此刻的綠島圖像。</p>",
      intro_en: "<p>Through reading and thinking, we try to understand the past and perceive the history and this land we have never experienced, connecting with the present while responding through one’s life experience. Using free association and collage of colors and shapes, writings are converted into visual creations and collaged into our own picture of Green Island today.</p>",
      url:"https://medium.com/greenislandhumanrightartfestival/workshop-%E9%96%B1%E8%AE%80-%E4%B8%80%E5%B9%85%E7%B6%A0%E5%B3%B6%E5%9C%96%E5%83%8F-cbf9db8aec72",
    },
    {
      author_zh: "李意婕、薛筑瑄、唐寧憶、周穎欣、魯直葳、呂岱樺、邱思頴、羅棋諠",
      author_en: "Lee I-Chieh, Hsueh Chu-Hsuan, Tang Ning-I, Chao Weng-Ian, Lu Chih-Wei, Lu Tai-Hua, Ciou Sih-Ying, Lo Chi-Hsuan",
      title_zh: "島民之外",
      title_en: "The Outsiders",
      date: "5/14（五）13:15-15:50．5/17（一）13:15-15:50",
      location_zh: "地點：白色恐怖綠島紀念園區 人權紀念碑下",
      location_en: "Venue: Monument for Human Rights, Green Island White Terror Memorial Park",
      intro_zh: "<p>本工作坊以綠島新生訓導處發生之故事為創作基底，從原創繪本分享開始，帶入教育劇場的操作與互動體驗，與參與者共同探索那段監禁的歷史、反思當代人權課題。</p>",
      intro_en: "<p>Based on the stories taking place at the New Life Correction Center, this workshop starts from storytelling of an original picture book, and moves to a theatre performance in an educational setting interactively. In so doing, it attempts to explore the imprisoned past and reflect on the present human rights issues with the participants.</p>",
      url:"https://medium.com/greenislandhumanrightartfestival/workshop-%E5%B3%B6%E6%B0%91%E4%B9%8B%E5%A4%96-the-outsiders-79cc44f2c815",
    },
    {
      author_zh: "劉紀彤",
      author_en: "Liu Chi-Tung",
      title_zh: "從桃花源到下水道——鱸鰻溝走讀活動",
      title_en: "From Shangri-la to Sewers – A Walk along Liumagou",
      date: "5/29 (六） 14:00-16:00",
      location_zh: "地點：白色恐怖綠島紀念園區",
      location_en: "Venue: Green Island White Terror Memorial Park",
      intro_zh: "<p>藉由身體的經驗，帶領參與者透過水文踏查、當地歷史記憶分享，在土地上體驗存在與消失。</p>",
      intro_en: "<p>Using physical experience, the workshop guides participants to experience existences and disappearances on the island via hydrological survey and camping.</p>",
      url:"https://medium.com/greenislandhumanrightartfestival/workshop-從桃花源到下水道-鱸鰻溝走讀活動-99c262fb6437",
    },
    {
      author_zh: "林彥翔",
      author_en: "Lin Yan-Xiang",
      title_zh: "島嶼影像館",
      title_en: "Island Photo Studio",
      date: "7/31(日）13:30-16:00",
      location_zh: "地點：白色恐怖綠島紀念園區",
      location_en: "Venue: Green Island White Terror Memorial Park",
      intro_zh: "<p>照片製成一條龍，帶領參與者從製作針孔相機開始，園區拍攝後進入暗房沖洗相片。</p>",
      intro_en: "<p>The workshop shows participants how a photograph is produced from ground zero, beginning with the making of a spy camera and bringing participants into the park for photography before developing the images in the darkroom.</p>",
      url:"https://medium.com/greenislandhumanrightartfestival/workshop-島嶼影像館-cd6f101ecf6e",
    },
    {
      author_zh: "周心瑀",
      author_en: "Chou Hsin-Yu",
      title_zh: "綠島聲音計畫",
      title_en: "Green Island Sound Project",
      date: "8/21(六） 14:00-15:30．8/29(日） 14:00-15:30",
      location_zh: "地點：白色恐怖綠島紀念園區",
      location_en: "Venue: Green Island White Terror Memorial Park",
      intro_zh: "<p>從環境聲音的聆聽開發感知，以聲音和肢體與這片土地、風、海洋進行互動。</p>",
      intro_en: "<p>Developing sensory perception by listening to environmental sounds, the workshop revolves around interacting with the land, wind and ocean through sounds and physical movements.</p>",
      url:"https://medium.com/greenislandhumanrightartfestival/綠島聲音計畫工作坊-316ac4adeebe",
    },
    // {
    //   author_zh: "",
    //   author_en: "",
    //   title_zh: "",
    //   title_en: "",
    //   date: "",
    //   location_zh: "",
    //   location_en: "",
    //   intro_zh: "<p></p>",
    //   intro_en: "<p></p>",
    // },
  ],
};

export default data;
